import React from "react";
import { useState } from "react";


/**
 * Hook for adding loading indication
 *
 * Returns functions to mark the loading started, to mark the loading finished, and to render the loading indicator component. All functions take
 * operationKey argument, which can be used to distinguish between multiple operations
 *
 * @param IndicatorCmponent the component which is rendered by the renderComponentIfLoading
 *
 */
const useLoadingIndication = (IndicatorCmponent = <></>) => {

  const [loadingCount, setLoadingCount] = useState({});

  const loadingStarted = (operationKey='') => {
    // eslint-disable-next-line no-magic-numbers
    setLoadingCount( { [operationKey]: loadingCount[operationKey] ?? 0 + 1 });
  };

  const loadingFinished = (operationKey = '') => {
    // eslint-disable-next-line no-magic-numbers
    setLoadingCount( { [operationKey]: loadingCount[operationKey] ?? 0 - 1 });
  };

  const renderComponentIfLoading = (operationKey='') => {
    // eslint-disable-next-line no-magic-numbers
    return loadingCount[operationKey] > 0? IndicatorCmponent : null;
  };

  return [loadingStarted, loadingFinished, renderComponentIfLoading];
};

export {
  useLoadingIndication
};
